<script setup lang="ts">
import { ActionButton, useTheme } from '@thehotelsnetwork/widgets-core';

const props = defineProps<{
  section: string;
}>();

const emit = defineEmits([
  'close',
  'back',
]);

const theme = useTheme();
</script>
<template>
  <div
    class="flex items-center py-2 px-3 justify-between sectionHeader"
  >
    <ActionButton
      type="back"
      :over-color="theme.backgroundColor.base"
      @action-click="emit('back')"
    />
    <h2 class="text-base font-semibold">
      {{ props.section }}
    </h2>
    <ActionButton
      type="close"
      :over-color="theme.backgroundColor.base"
      @action-click="emit('close')"
    />
  </div>
</template>

<style scoped>
.sectionHeader {
  background-color: v-bind(theme.backgroundColor.washed);
}
</style>
